<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/mapmatch")
          i.fa.fa-link
          span.ml-1 {{ $t("ui.map_match") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-link
                    b-form-select(v-model="linked" @change="changeMap")
                      option(value="false") {{ $t('ui.not_mapped') }}
                      option(value="true") {{ $t('ui.mapped') }}
                div.col-md-2.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t("ui.is_backup") }}
                      b-form-select(v-model="isBackup")
                        option(value="") {{ $t('ui.all') }}
                        option(value="true") {{ $t('ui.yes') }}
                        option(value="false") {{ $t('ui.no') }}
                div.col-md-2.mb-1
                  sync.mb-1.mr-2(@clicked="getMatchList()")
                  //- SubmitButton(
                  //-   :loading="loading"
                  //-   icon="fa fa-unlink"
                  //-   :text="$t('ui.unmap')"
                  //-   type="button"
                  //-   @click="unmapMatch()"
                  //-   variant="secondary"
                  //-   size="sm"
                  //-   v-if="showUnmapButton()"
                  //- ).mb-1.mr-2
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.far.fa-clock
                    b-form-select(v-model="marketType" @change="marketOnChange($event)")
                      option(value="") {{ $t('ui.all') }}
                      option(value="early") {{ $t('ui.early') }}
                      option(value="today") {{ $t('ui.today') }}
                      option(value="live") {{ $t("ui.live") }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.type') }}
                    b-form-select(v-model="gameType")
                      option(value="") {{ $t('ui.all') }}
                      option(value="fulltime") {{ $t('ui.fulltime') }}
                      option(value="corners") {{ $t('ui.corners') }}
                      option(value="specific") {{ $t('ui.specific') }}
                      option(value="specials") {{ $t("ui.specials") }}
                      option(value="bookings") {{ $t("ui.bookings") }}
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="match_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-       option(value="match_date") {{ $t("ui.match_date") }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1(v-if="marketType != ''")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1(v-if="marketType != ''")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getMatchList()"
                    variant="success"
                    size="sm"
                    ).mb-1.mr-2
                  SubmitButton(
                      :loading="loading"
                      icon="fa fa-link"
                      :text="$t('ui.map')"
                      type="button"
                      @click="mapMatch()"
                      variant="secondary"
                      size="sm"
                      v-if="firstMatchIdSelected!='' && secondMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).mb-1.mr-2
                div.col-md-2.mb-1
                  SubmitButton.float-right(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.swap')"
                    type="button"
                    @click="swapMapMatch()"
                    variant="warning"
                    size="sm"
                    v-if="firstMatchIdSelected!='' && secondMatchIdSelected !='' && curLinkedValue == 'false'"
                  ).mb-1
        div.card-body
          div.row.mb-5
            // SBO
            div.col-6
              div.row.mb-2
                div.col-md-2
                  b-input-group(size="sm")
                    b-input(:value="firstProvider" readonly)
                    b-input(:value="filterFirstMatchListLength" readonly)
                div.col-md-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="firstMatchSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                    b-form-radio-group(
                      buttons
                      v-model="matchFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="match_id") {{ $t("ui.id") }}
                      b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                      b-form-radio(value="home_team") {{ $t("ui.home") }}
                      b-form-radio(value="away_team") {{ $t("ui.away") }}
                div.col-md-3.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-plus"
                    :text="$t('ui.add')"
                    type="button"
                    @click="addMatch('firstMatch')"
                    variant="info"
                    size="sm"
                    v-if="firstMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).ml-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-plus"
                    :text="$t('ui.add_special')"
                    type="button"
                    @click="addSpecialMatch('firstMatch')"
                    variant="info"
                    size="sm"
                    v-if="firstMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).ml-2
                //- div.col-md-4
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-calendar
                //-     date-picker(v-model="firstMatchDateFilter" :config="locale")
                //-     SubmitButton(
                //-       :loading="loading"
                //-       icon="fa fa-plus"
                //-       :text="$t('ui.add')"
                //-       type="button"
                //-       @click="addMatch('firstMatch')"
                //-       variant="info"
                //-       size="sm"
                //-       v-if="firstMatchIdSelected !='' && curLinkedValue == 'false'"
                //-       ).ml-2
              div.row.mb-1
                div.col-12.clusterize
                  div#tblFirstMatch.clusterize-scroll
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_id', 'first')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('match_id', 'first')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('sport_type', 'first')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'first')")
                          th.sticky-position(style="width: 30%;" @click="sortOrder('league_name', 'first')")
                            span {{ $tc('ui.leagues', 1) }}
                            i(:class="changeSortKey('league_name', 'first')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_date', 'first')")
                            span {{ $t('ui.short.match_date') }}
                            i(:class="changeSortKey('match_date', 'first')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('home_team', 'first')")
                            span {{ $t('ui.home') }}
                            i(:class="changeSortKey('home_team', 'first')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('away_team', 'first')")
                            span {{ $t('ui.away') }}
                            i(:class="changeSortKey('away_team', 'first')")
                      tbody.clusterize-content
                        tr(
                          v-for="(firstMatchInfo, index) in filterFirstMatchList"
                          @click="rowSelect(firstMatchInfo, 'firstMatch')"
                          :class="{ 'selectedRow' : selectedRow(firstMatchInfo, 'firstMatch') }"
                          :ref="firstMatchInfo.match_id"
                          )
                          td
                            span {{ firstMatchInfo.match_id }}
                          td
                            span {{ firstMatchInfo.sport_type }}
                          td
                            span(:title="firstMatchInfo.league_name + ' [' + firstMatchInfo.league_id + ']'") {{ firstMatchInfo.league_name }}
                          td
                            span {{ $moment(firstMatchInfo.match_date).format("DD-MM-YYYY") }}
                          td
                            span(:title="firstMatchInfo.home_team + ' [' + firstMatchInfo.home_id + ']'") {{ firstMatchInfo.home_team }}
                          td
                            span(:title="firstMatchInfo.away_team + ' [' + firstMatchInfo.away_id + ']'") {{ firstMatchInfo.away_team }}
            // IBC / CMD
            div.col-6
              div.row.mb-2
                div.col-md-2
                  b-input-group(size="sm")
                    b-form-select(v-model="secondProvider")
                      option(value="IBC") {{ $t('ui.ibc') }}
                      //- option(value="CMD" disabled) {{ $t('ui.cmd') }}
                    b-input(:value="filterSecondMatchListLength" readonly)
                div.col-md-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="secondMatchSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                    b-form-radio-group(
                      buttons
                      v-model="matchFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="match_id") {{ $t("ui.id") }}
                      b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                      b-form-radio(value="home_team") {{ $t("ui.home") }}
                      b-form-radio(value="away_team") {{ $t("ui.away") }}
                div.col-md-3.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-plus"
                    :text="$t('ui.add')"
                    type="button"
                    @click="addMatch('secondMatch')"
                    variant="info"
                    size="sm"
                    v-if="secondMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).ml-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-plus"
                    :text="$t('ui.add_special')"
                    type="button"
                    @click="addSpecialMatch('secondMatch')"
                    variant="info"
                    size="sm"
                    v-if="secondMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).ml-2
              div.row.mb-1
                div.col-12.clusterize
                  div#tblSecondMatch.clusterize-scroll
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_id', 'second')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('match_id', 'second')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('sport_type', 'second')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'second')")
                          th.sticky-position(style="width: 30%;" @click="sortOrder('league_name', 'second')")
                            span {{ $tc('ui.leagues', 1) }}
                            i(:class="changeSortKey('league_name', 'second')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_date', 'second')")
                            span {{ $t('ui.short.match_date') }}
                            i(:class="changeSortKey('match_date', 'second')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('home_team', 'second')")
                            span {{ $t('ui.home') }}
                            i(:class="changeSortKey('home_team', 'second')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('away_team', 'second')")
                            span {{ $t('ui.away') }}
                            i(:class="changeSortKey('away_team', 'second')")
                      tbody.clusterize-content
                        tr(
                          v-for="(secondMatchInfo, index) in filterSecondMatchList"
                          @click="rowSelect(secondMatchInfo, 'secondMatch')"
                          :class="{ 'selectedRow' : selectedRow(secondMatchInfo, 'secondMatch') }"
                          :ref="secondMatchInfo.match_id"
                          )
                          td
                            span {{ secondMatchInfo.match_id }}
                          td
                            span {{ secondMatchInfo.sport_type }}
                          td
                            span(:title="secondMatchInfo.league_name + ' [' + secondMatchInfo.league_id + ']'") {{ secondMatchInfo.league_name }}
                          td
                            span {{ $moment(secondMatchInfo.match_date).format("DD-MM-YYYY") }}
                          td
                            span(:title="secondMatchInfo.home_team + ' [' + secondMatchInfo.home_id + ']'") {{ secondMatchInfo.home_team }}
                          td
                            span(:title="secondMatchInfo.away_team + ' [' + secondMatchInfo.away_id + ']'") {{ secondMatchInfo.away_team }}
</template>
<script>
import config from "@/config";
import preadd from "@/preadd";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import VueScrollTo from "vue-scrollto";
import sync from "@/components/sync.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    VueScrollTo,
    sync
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    firstMatchList: [],
    secondMatchList: [],
    firstProvider: "SBO",
    secondProvider: "IBC",
    curLinkedValue: "",
    linked: "false",
    firstMatchIdSelected: "",
    secondMatchIdSelected: "",
    firstMatchSelected: {},
    secondMatchSelected: {},
    firstSortKey: "league_name",
    firstSortType: "asc",
    secondSortKey: "league_name",
    secondSortType: "asc",
    matchFilterBy: "league_name",
    startDate: null,
    endDate: null,
    marketType: "today",
    gameType: "",
    matchLink: "",
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    isAddMatchCase: false,
    leagueSpecialName: '',
    parentMatchList: [],
    parentLeagueList: [],
    parentMatch: null,
    fms: "",
    sms: "",
    childHomeName: "",
    childAwayName: "",
    childLeagueName: "",
    parentLeagueId: "",
    preferParentLeagueName: "",
    isSpecial: null,
    isBackup: "true"
  }),
  computed: {
    filterCache() {
      return this.$store.getters.mapMatchCache;
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    filterFirstMatchListLength() {
      if (this.filterFirstMatchList) {
        return this.filterFirstMatchList.length;
      } else {
        return 0;
      }
    },
    filterFirstMatchList() {
      return this.firstMatchList.filter(item => {
        if (this.matchFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "match_id") return item.match_id.toString().indexOf(this.firstMatchSearch) > -1;
      })
      .sort((a, b) => {
        if (this.firstSortType == 'asc')
          return a[this.firstSortKey] > b[this.firstSortKey] ? 1 : -1;
        else
          return a[this.firstSortKey] < b[this.firstSortKey] ? 1 : -1;
      });
    },
    firstMatchSearch:
    {
      get() {
        return this.fms;
      },
      set(value) {
        this.fms = value;
        this.sms = value;
      }
    },
    secondMatchSearch:
    {
      get() {
        return this.sms;
      },
      set(value) {
        this.sms = value;
      }
    },
    filterSecondMatchListLength() {
      if (this.filterSecondMatchList) {
        return this.filterSecondMatchList.length;
      } else {
        return 0;
      }
    },
    filterSecondMatchList() {
      return this.secondMatchList.filter(item => {
        if (this.matchFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "match_id") return item.match_id.toString().indexOf(this.secondMatchSearch) > -1;
      })
      .sort((a, b) => {
        if (this.secondSortType == 'asc')
          return a[this.secondSortKey] > b[this.secondSortKey] ? 1 : -1;
        else
          return a[this.secondSortKey] < b[this.secondSortKey] ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.sportList = [];
    this.firstMatchList = [];
    this.secondMatchList = [];
  },
  mounted: function() {
    this.getSportList();
    // this.startDate = this.yesterday;
    // this.endDate = this.today;
    this.sportType = this.filterCache.sport;
    this.linked = this.filterCache.linked;
    this.isBackup = this.filterCache.isBackup;
    this.marketType = this.filterCache.market;
    this.gameType = this.filterCache.game;
    this.startDate = this.filterCache.startDate;
    this.endDate = this.filterCache.endDate;
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key, type) {
      if (type == 'first') {
        if (this.firstSortKey == key)
          this.firstSortType = this.firstSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.firstSortKey = key;
          this.firstSortType = 'asc';
        }
      } else if (type == 'second') {
        if (this.secondSortKey == key)
          this.secondSortType = this.secondSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.secondSortKey = key;
          this.secondSortType = 'asc';
        }
      }
    },
    changeSortKey(key, type) {
      if (type == 'first') {
        if (this.firstSortKey != key)
          return 'fas fa-sort';
        else if (this.firstSortKey == key && this.firstSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.firstSortKey == key && this.firstSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'second') {
        if (this.secondSortKey != key)
          return 'fas fa-sort';
        else if (this.secondSortKey == key && this.secondSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.secondSortKey == key && this.secondSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    changeMap: function() {
      this.getMatchList();
    },
    showUnmapButton() {
      if (this.isAddMatchCase) return (this.firstMatchIdSelected != "" || this.secondMatchIdSelected != "") && this.curLinkedValue == "true";
      else return this.firstMatchIdSelected != "" && this.secondMatchIdSelected != "" && this.curLinkedValue == "true";
    },
    showTooltip: function(e) {
      if (e.srcElement.offsetWidth < e.srcElement.scrollWidth) {
        e.srcElement.title = e.srcElement.innerText;
      }
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = [];
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id == 1; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedFilterCache: function() {
      var json = {
        sport: this.sportType,
        linked: this.linked,
        isBackup: this.isBackup,
        market: this.marketType,
        game: this.gameType,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$store.dispatch("layout/setMapMatchCache", json);
    },
    getMatchList: function() {
      this.reset();

      this.curLinkedValue = this.linked;

      this.changedFilterCache();

      let url = config.mapMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch,
        sport_id: this.sportType,
        linked: this.linked,
        is_backup: this.isBackup == '' ? null : this.isBackup,
        map_from: this.firstProvider.toLowerCase(),
        map_to: this.secondProvider.toLowerCase(),
        market_type: this.marketType,
        match_type: this.gameType,
        match_date_from: this.startDate,
        match_date_to: this.endDate,
        ignore_date_range: this.marketType == '' ? true : false,
        sort_key: this.sortKey,
        sort_type: this.sortType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.firstMatchList = [];
                this.secondMatchList = [];
                this.firstMatchList = response.data.tbl_map_match_list.Table;
                this.secondMatchList = response.data.tbl_map_match_list.Table1;
                // this.firstMatchList = Object.preventExtensions(response.data.tbl_map_match_list.Table);
                // this.secondMatchList = Object.preventExtensions(response.data.tbl_map_match_list.Table1);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedRow: function(info, type) {
      if (type == "firstMatch") {
        if (this.firstMatchIdSelected == info.match_id) return true;
      } else if (type == "secondMatch") {
        if (this.secondMatchIdSelected == info.match_id) return true;
      }

      return false;
    },
    rowSelect: function(matchInfo, type) {
      if (this.curLinkedValue == "true") {
        if (type == "firstMatch") {
          this.firstMatchIdSelected = matchInfo.match_id;

          if (
            this.secondMatchList.filter(item => {
              return item.match_link == matchInfo.match_link;
            }).length > 0
          ) {
            this.secondMatchIdSelected = this.secondMatchList.filter(item => {
              return item.match_link == matchInfo.match_link;
            })[0].match_id;
            this.isAddMatchCase = false;
          } else {
            this.secondMatchIdSelected = "";
            this.isAddMatchCase = true;
          }
        } else if (type == "secondMatch") {
          this.secondMatchIdSelected = matchInfo.match_id;

          if (
            this.firstMatchList.filter(item => {
              return item.match_link == matchInfo.match_link;
            }).length > 0
          ) {
            this.firstMatchIdSelected = this.firstMatchList.filter(item => {
              return item.match_link == matchInfo.match_link;
            })[0].match_id;
            this.isAddMatchCase = false;
          } else {
            this.firstMatchIdSelected = "";
            this.isAddMatchCase = true;
          }
        }

        this.matchLink = matchInfo.match_link;

        if (!this.isAddMatchCase) {
          var VueScrollTo = require("vue-scrollto");

          var options = {
            container: type == "firstMatch" ? "#tblSecondMatch" : "#tblFirstMatch",
            offset: -200
          };

          var elem = type == "firstMatch" ? this.$refs[this.secondMatchIdSelected][0] : this.$refs[this.firstMatchIdSelected][0];

          VueScrollTo.scrollTo(elem, "500", options);
        }
      } else {
        if (type == "firstMatch") {
          setTimeout(() => {
            this.firstMatchIdSelected = matchInfo.match_id;
            this.firstMatchSelected = matchInfo;
          }, 1);
        } else if (type == "secondMatch") {
          setTimeout(() => {
            this.secondMatchIdSelected = matchInfo.match_id;
            this.secondMatchSelected = matchInfo;
          }, 1);
        }
      }
    },
    swapMapMatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.swap_map_match"),
          width: 1300,
          html:
            '<div class="col">' +
            '<div class="row">' +
            '<div class="col-md-12 mb-3">' +
            '<span>'+ this.$t("message.swap_map_match_confirm") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-md-1 mb-1">' +
            '<span>'+ this.$t("ui.sbo") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row mb-2">' +
            '<div class="col-md-12">' +
            '<table class="tablex" style="width: 100%;">' +
            '<thead><tr>' +
            '<th class="sticky-position" style="width: 60%;"><span>' + this.$tc("ui.leagues", 1) + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.home") + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.away") + '</span></th>' +
            '</tr></thead>' +
            '<tbody><tr>' +
            '<td><span>' + this.firstMatchSelected.league_name + '</span></td>' +
            '<td><span>' + this.firstMatchSelected.home_team + '</span></td>' +
            '<td><span>' + this.firstMatchSelected.away_team + '</span></td>' +
            '</tr></tbody>' +
            '</table>' +
            '</div>' +
            '</div>' +

            '<div class="row">' +
            '<div class="col-md-1 mb-1">' +
            '<span>'+ this.$t("ui.ibc") +'</span>' +
            '</div>' +
            '</div>' +
            '<div class="row">' +
            '<div class="col-md-12">' +
            '<table class="tablex" style="width: 100%;">' +
            '<thead><tr>' +
            '<th class="sticky-position" style="width: 60%;"><span>' + this.$tc("ui.leagues", 1) + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.home") + '</span></th>' +
            '<th class="sticky-position" style="width: 20%;"><span>' + this.$t("ui.away") + '</span></th>' +
            '</tr></thead>' +
            '<tbody><tr>' +
            '<td><span>' + this.secondMatchSelected.league_name + '</span></td>' +
            '<td><span>' + this.secondMatchSelected.home_team + '</span></td>' +
            '<td><span>' + this.secondMatchSelected.away_team + '</span></td>' +
            '</tr></tbody>' +
            '</table>' +
            '</div>' +
            '</div>' +
            '</div>',
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMapMatch(true);
          }
        });
    },
    mapMatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.map_match"),
          text: this.$t("message.map_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMapMatch(false);
          }
        });
    },
    confirmMapMatch: function(isSwap) {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        if (isSwap) url = config.swapMapMatchManualSBOIBCUrl();
        else url = config.mapMatchManualSBOIBCUrl();
        json.sbo_match = this.firstMatchIdSelected;
        json.ibc_match = this.secondMatchIdSelected;
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        if (isSwap) url = config.swapMapMatchManualSBOCMDUrl();
        else url = config.mapMatchManualSBOCMDUrl();
        json.sbo_match = this.firstMatchIdSelected;
        json.cmd_match = this.secondMatchIdSelected;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeMatchFromList("map");
                // this.$helpers.showDialog(this.$t("ui.combine.map_match"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    unmapMatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.unmap_match"),
          text: this.$t("message.unmap_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnmapMatch();
          }
        });
    },
    confirmUnmapMatch: function() {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.unmapMatchManualSBOIBCUrl();
        json.sbo_match = this.firstMatchIdSelected == "" ? 0 : this.firstMatchIdSelected;
        json.ibc_match = this.secondMatchIdSelected == "" ? 0 : this.secondMatchIdSelected;
        json.is_add_match = this.isAddMatchCase;
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        url = config.unmapMatchManualSBOCMDUrl();
        json.sbo_match = this.firstMatchIdSelected == "" ? 0 : this.firstMatchIdSelected;
        json.cmd_match = this.secondMatchIdSelected == "" ? 0 : this.secondMatchIdSelected;
        json.is_add_match = this.isAddMatchCase;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeMatchFromList("unmap");
                // this.$helpers.showDialog(this.$t("ui.combine.unmap_match"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    // checkExceptionCase(type) {
    //   if (type == 'firstMatch') {
    //     for(var j = 0; j < config.leagueSpecialException.length; j++) {
    //       if (this.firstMatchSelected.league_name.trim().toLowerCase().includes(config.leagueSpecialException[j])) {
    //         if(config.teamSpecialException[config.leagueSpecialException[j]]) {
    //           if (this.firstMatchSelected.home_team.trim().toLowerCase().includes(config.teamSpecialException[config.leagueSpecialException[j]].home) &&
    //               this.firstMatchSelected.away_team.trim().toLowerCase().includes(config.teamSpecialException[config.leagueSpecialException[j]].away))
    //           {
    //             this.isSpecial = false;
    //             return;
    //           }
    //         } else {
    //           this.isSpecial = false;
    //           return;
    //         }
    //       }
    //     }
    //   } else if (type == 'secondMatch') {
    //     for(var j = 0; j < config.leagueSpecialException.length; j++) {
    //       if (this.secondMatchSelected.league_name.trim().toLowerCase().includes(config.leagueSpecialException[j])) {
    //         if(config.teamSpecialException[config.leagueSpecialException[j]]) {
    //           if (this.secondMatchSelected.home_team.trim().toLowerCase().includes(config.teamSpecialException[config.leagueSpecialException[j]].home) &&
    //               this.secondMatchSelected.away_team.trim().toLowerCase().includes(config.teamSpecialException[config.leagueSpecialException[j]].away))
    //           {
    //             this.isSpecial = false;
    //             return;
    //           }
    //         } else {
    //           this.isSpecial = false;
    //           return;
    //         }
    //       }
    //     }
    //   }
    // },
    checkExceptionCase(type) {
      if (type == 'firstMatch') {
        for(var j = 0; j < config.addMatchException.length; j++) {
          var obj = config.addMatchException[j];
          if (obj.checkLeague == true && obj.checkTeam == true) {
            if (this.firstMatchSelected.league_name.trim().toLowerCase().includes(obj.league.trim().toLowerCase())) {
              if (this.firstMatchSelected.home_team.trim().toLowerCase().includes(obj.home.trim().toLowerCase()) &&
                  this.firstMatchSelected.away_team.trim().toLowerCase().includes(obj.away.trim().toLowerCase())) {
                this.isSpecial = false;
              }
            }
          }
          else if (obj.checkLeague == true && obj.checkTeam == false) {
            if (this.firstMatchSelected.league_name.trim().toLowerCase().includes(obj.league.trim().toLowerCase())) {
              this.isSpecial = false;
            }
          }
          else if (obj.checkLeague == false && obj.checkTeam == true) {
            if (this.firstMatchSelected.home_team.trim().toLowerCase().includes(obj.home.trim().toLowerCase()) &&
                this.firstMatchSelected.away_team.trim().toLowerCase().includes(obj.away.trim().toLowerCase())) {
              this.isSpecial = false;
            }
          }
          else
            return;
        }
      } else if (type == 'secondMatch') {
        for(var j = 0; j < config.addMatchException.length; j++) {
          var obj = config.addMatchException[j];
          if (obj.checkLeague == true && obj.checkTeam == true) {
            if (this.secondMatchSelected.league_name.trim().toLowerCase().includes(obj.league.trim().toLowerCase())) {
              if (this.secondMatchSelected.home_team.trim().toLowerCase().includes(obj.home.trim().toLowerCase()) &&
                  this.secondMatchSelected.away_team.trim().toLowerCase().includes(obj.away.trim().toLowerCase())) {
                this.isSpecial = false;
              }
            }
          }
          else if (obj.checkLeague == true && obj.checkTeam == false) {
            if (this.secondMatchSelected.league_name.trim().toLowerCase().includes(obj.league.trim().toLowerCase())) {
              this.isSpecial = false;
            }
          }
          else if (obj.checkLeague == false && obj.checkTeam == true) {
            if (this.secondMatchSelected.home_team.trim().toLowerCase().includes(obj.home.trim().toLowerCase()) &&
                this.secondMatchSelected.away_team.trim().toLowerCase().includes(obj.away.trim().toLowerCase())) {
              this.isSpecial = false;
            }
          }
          else
            return;
        }
      }

      return;
    },
    addMatch: function(matchType) {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.add_match"),
          text: this.$t("message.add_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.isSpecial = null;
            this.checkExceptionCase(matchType);
            if (matchType == 'firstMatch') {
              if (this.isSpecial != null)
                this.confirmAddMatch(matchType);
              else
                this.checkIsSpecialMatchSBO(matchType, 'normal');
            }
            else if (matchType == 'secondMatch') {
              if (this.isSpecial != null)
                this.confirmAddMatch(matchType);
              else
                this.checkIsSpecialMatchIBC(matchType, 'normal');
            }
          }
        });
    },
    addSpecialMatch: function(matchType) {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.add_special_match"),
          text: this.$t("message.add_special_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.isSpecial = null;
            this.checkExceptionCase(matchType);
            if (matchType == 'firstMatch') {
              if (this.isSpecial != null)
                this.confirmAddSpecialMatchSBO(matchType);
              else
                this.checkIsSpecialMatchSBO(matchType, 'special');
            }
            else if (matchType == 'secondMatch') {
              if (this.isSpecial != null)
                this.confirmAddSpecialMatchIBC(matchType);
              else
                this.checkIsSpecialMatchIBC(matchType, 'special');
            }
          }
        });
    },
    checkIsSpecialMatchSBO(type, addType) {
      let url = config.getParentMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (type == "firstMatch") {
        json.provider_id = this.firstProvider.toLowerCase();
        json.child_match_id = this.firstMatchIdSelected;
      } else {
        json.provider_id = this.secondProvider.toLowerCase();
        json.child_match_id = this.secondMatchIdSelected;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.parentMatchList = [];
                this.parentMatchList = response.data.tbl_parent_match;
                this.parentMatch = this.parentMatchList.length > 0 ? response.data.tbl_parent_match[0] : {};
                this.isSpecial = this.parentMatchList.length > 0 ? true : false;
              } else {
                if (this.feedback.status == 'refIdNotFound')
                  this.isSpecial = false;
              }

              if (addType == 'normal')
                this.confirmAddMatch(type);
              else if (addType == 'special')
                this.confirmAddSpecialMatchSBO(type);
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmAddMatch: function(type) {
      let url = config.addMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (type == "firstMatch") {
        json.provider_id = this.firstProvider.toLowerCase();
        json.match_id = this.firstMatchIdSelected;
      } else {
        json.provider_id = this.secondProvider.toLowerCase();
        json.match_id = this.secondMatchIdSelected;
      }

      if (this.isSpecial != null && !this.isSpecial) {
        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.isSpecial = null;
                  this.removeMatchFromList("add", type);
                  // this.$helpers.showDialog(this.$t("ui.combine.add_match"), this.$t("message.success"), "success");
                  this.$snotify.success(this.$t("message.success"));
                } else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.isSpecialMatch"), "error");
      }
    },
    confirmAddSpecialMatchSBO: function(type) {
      if (this.isSpecial) {
        var homeId = '';
        var awayId = '';

        if (this.parentMatch.child_home_name.trim().toLowerCase().includes(this.parentMatch.home_team.toLowerCase()))
          homeId = this.parentMatch.home_id;
        else
          homeId = this.parentMatch.away_id;

        if (this.parentMatch.child_away_name.trim().toLowerCase().includes(this.parentMatch.away_team.toLowerCase()))
          awayId = this.parentMatch.away_id;
        else
          awayId = this.parentMatch.home_id;

        let url = config.addSpecialMatchUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.mapmatch,
          provider_id: type == 'firstMatch' ? this.firstProvider.toLowerCase() : this.secondProvider.toLowerCase(),
          child_match_id: type == 'firstMatch' ? this.firstMatchIdSelected : this.secondMatchIdSelected,
          parent_match_id: this.parentMatch.match_id,
          league_id: this.parentMatch.league_id,
          home_id: homeId,
          away_id: awayId
        };

        this.$http.post(url, json).then(
          function(response) {
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.isSpecial = null;
                  this.removeMatchFromList("add", type);

                  this.$snotify.success(this.$t("message.success"));
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.notSpecialMatch"), "error");
      }
    },
    checkIsSpecialMatchIBC(type, addType) {
      console.log(type, addType);
      let url = config.getParentLeagueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (type == "firstMatch") {
        json.provider_id = this.firstProvider.toLowerCase();
        json.child_match_id = this.firstMatchIdSelected;
      } else {
        json.provider_id = this.secondProvider.toLowerCase();
        json.child_match_id = this.secondMatchIdSelected;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.parentLeagueList = [];
                this.parentLeagueList = response.data.tbl_league_parent_list;
                this.isSpecial = this.parentLeagueList.length > 0 ? true : false;
              } else {
                if (this.feedback.status == 'parentLeagueNotFound')
                  this.isSpecial = false;
              }

              if (addType == 'normal')
                this.confirmAddMatch(type);
              else if (addType == 'special')
                this.confirmAddSpecialMatchIBC(type);
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmAddSpecialMatchIBC: function(type) {
      let url = config.getParentLeagueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch
      };

      if (type == "firstMatch") {
        json.provider_id = this.firstProvider.toLowerCase();
        json.child_match_id = this.firstMatchIdSelected;
      } else {
        json.provider_id = this.secondProvider.toLowerCase();
        json.child_match_id = this.secondMatchIdSelected;
      }

      if (this.isSpecial) {
        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.parentLeagueList = [];
                  this.parentLeagueList = response.data.tbl_league_parent_list;
                  this.preferParentLeagueName = this.parentLeagueList.length > 0 ? this.parentLeagueList[0].prefer_parent_league_name : '';
                  this.childLeagueName = this.parentLeagueList.length > 0 ? this.parentLeagueList[0].child_league_name : '';
                  this.parentLeagueId = this.parentLeagueList.length > 0 ? this.parentLeagueList[0].parent_league_id : '';
                  this.getParentMatchListIBC(type);
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.notSpecialMatch"), "error");
      }

    },
    getParentMatchListIBC: function(type) {
      let url = config.parentMatchListUrl();

      this.leagueSpecialName = this.childLeagueName.replace(this.preferParentLeagueName, "");

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch,
        parent_league_id: this.parentLeagueId
      };

      if (type == "firstMatch") {
        json.provider_id = this.firstProvider.toLowerCase();
        json.child_match_id = this.firstMatchIdSelected;
      } else {
        json.provider_id = this.secondProvider.toLowerCase();
        json.child_match_id = this.secondMatchIdSelected;
      }


      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.parentMatchList = [];
                this.parentMatchList = response.data.tbl_match_parent_list;
                this.childHomeName = this.parentMatchList.length > 0 ? this.parentMatchList[0].child_home_name : '';
                this.childAwayName = this.parentMatchList.length > 0 ? this.parentMatchList[0].child_away_name : '';
                this.findParentMatchIBC(type);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    findParentMatchIBC(type) {
      var specialList = preadd.specificOption.filter(item => { return item.alias == this.leagueSpecialName.trim(); });
      var foundParent = false;

      for(var j = 0; j < this.parentMatchList.length; j++) {
        if (
          (this.childHomeName.trim().toLowerCase().includes(this.parentMatchList[j].home_name.toLowerCase()) || this.childHomeName.trim().toLowerCase().includes(this.parentMatchList[j].home_name.toLowerCase().replace('(n)','').trim()))
            && (this.childAwayName.trim().toLowerCase().includes(this.parentMatchList[j].away_name.toLowerCase()) || this.childAwayName.trim().toLowerCase().includes(this.parentMatchList[j].away_name.toLowerCase().replace('(n)','').trim())))
        {
          foundParent = true;
          this.addSpecialMatchInfoIBC(this.parentMatchList[j], type);
          break;
        }
      }

      // if (specialList.length > 0) {
      //   var cv = specialList[0].value;
      //   var consoleTeamlist = config.specificList[cv].team;

      //   for(var j = 0; j < this.parentMatchList.length; j++) {
      //     for(var i = 0; i < consoleTeamlist.length; i++) {
      //       if (this.parentMatchList[j].home_name.trim().includes(this.childHomeName.replace(consoleTeamlist[i], ""))
      //           && this.parentMatchList[j].away_name.trim().includes(this.childAwayName.replace(consoleTeamlist[i], ""))) {
      //         foundParent = true;
      //         this.addSpecialMatchInfoIBC(this.parentMatchList[j], type);
      //         break;
      //       }
      //     }
      //   }
      // } else {
      //   for(var j = 0; j < this.parentMatchList.length; j++) {
      //     if (this.childHomeName.trim().includes(this.parentMatchList[j].home_name)
      //         && this.childAwayName.trim().includes(this.parentMatchList[j].away_name)) {
      //       foundParent = true;
      //       this.addSpecialMatchInfoIBC(this.parentMatchList[j], type);
      //       break;
      //     }
      //   }
      // }

      if(foundParent == false)
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.parentMatchNotFound"), "error");
    },
    addSpecialMatchInfoIBC(obj, type) {
      let url = config.addSpecialMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatch,
        provider_id: type == 'firstMatch' ? this.firstProvider.toLowerCase() : this.secondProvider.toLowerCase(),
        child_match_id: type == 'firstMatch' ? this.firstMatchIdSelected : this.secondMatchIdSelected,
        parent_match_id: obj.match_id,
        league_id: obj.league_id,
        home_id: obj.home_id,
        away_id: obj.away_id
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.isSpecial = null;
                this.removeMatchFromList("add", type);

                this.$snotify.success(this.$t("message.success"));
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    removeMatchFromList: function(action, type) {
      type = type || "";

      if ((action == "add" && type == "firstMatch") || action == "map" || action == "unmap") {
        let i = this.firstMatchList
          .map(flInfo => {
            return flInfo.match_id;
          })
          .indexOf(this.firstMatchIdSelected);

        this.firstMatchList.splice(i, 1);
        this.firstMatchIdSelected = "";
      }

      if ((action == "add" && type == "secondMatch") || action == "map" || action == "unmap") {
        let j = this.secondMatchList
          .map(slInfo => {
            return slInfo.match_id;
          })
          .indexOf(this.secondMatchIdSelected);

        this.secondMatchList.splice(j, 1);
        this.secondMatchIdSelected = "";
      }
    },
    reset: function() {
      this.firstMatchIdSelected = "";
      this.secondMatchIdSelected = "";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>